import {Deserializable} from '../deserializable';

import {NhomMauVanBan} from '../danhmuc/nhommauvanban';
import {MauVanBanFile} from './mauvanbanfile';



export  class MauVanBan implements Deserializable {
  public  id: number;
  public  tenVanBan: string;
  public  ghiChu: string;
  public  maLoai: number;
  public  soVanThuID: number;
  public  nguoiNhapID: number;
  public  nhomMauVanBan: NhomMauVanBan;
  public  mauVanBanFiles: MauVanBanFile[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nhomMauVanBan = new NhomMauVanBan().deserialize(input.nhomMauVanBan);
    this.mauVanBanFiles = input.mauVanBanFiles.map(mauVanBanFiles => new MauVanBanFile().deserialize(mauVanBanFiles));
    return this;
  }
}
